import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { resetAlertToInitialState } from './AlertManagementSlice';
import { resetApprovedStationToInitialState } from './ApprovedStationManagementSlice';
import { resetDeviceToInitialState } from './DeviceManagementSlice';
import { resetBasePriceToInitialState } from './DynamicBasePriceManagementSlice';
import { resetOffPeakToInitialState } from './DynamicOffPeakPriceManagementSlice';
import { resetPeakPriceToInitialState } from './DynamicPeakPriceManagementSlice';
import { resetGuestChargingToInitialState } from './GuestChargingSlice';
import { resetMaintenanceToInitialState } from './MaintenanceScheduleManagementSlice';
import { resetRejectedStationToInitialState } from './RejectedStationManagementSlice';
import { resetReportSliceToInitialState } from './ReportSlice';
import { resetRoleToInitialState } from './RoleManagementSlice';
import { resetScheduleToInitialState } from './ScheduleManagementSlice';
import { resetTransactionToInitialState } from './TransactionManagementSlice';
import { resetUserToInitialState } from './UserManagementSlice';

export const resetAllSlices = createAsyncThunk('reset/resetAllSlices', async (_, { dispatch }) => {
  dispatch(resetAlertToInitialState());
  dispatch(resetApprovedStationToInitialState());
  dispatch(resetDeviceToInitialState());
  dispatch(resetBasePriceToInitialState());
  dispatch(resetOffPeakToInitialState());
  dispatch(resetPeakPriceToInitialState());
  dispatch(resetMaintenanceToInitialState());
  dispatch(resetRejectedStationToInitialState());
  dispatch(resetReportSliceToInitialState());
  dispatch(resetRoleToInitialState());
  dispatch(resetScheduleToInitialState());
  dispatch(resetScheduleToInitialState());
  dispatch(resetTransactionToInitialState());
  dispatch(resetUserToInitialState());
  dispatch(resetGuestChargingToInitialState());
});

const initialState = {};

const resetReduxStateSlice = createSlice({
  name: 'resetReduxState',
  initialState,
  reducers: {},
});

export default resetReduxStateSlice.reducer;
